/**
 * Site-contact API client (SSOT for the site-contact endpoints).
 *
 * A site contact belongs to a site, and every quote and job at that address
 * reads the same rows, so list/create are addressed by site id:
 *   GET/POST /site/<id>/site-contacts
 *   PUT/DELETE /site-contacts/<id>   (site inferred from the row server-side)
 *
 * Thin domain wrapper around window.apiClient for the site-contacts manager in
 * site_contacts.js. Exposed on window.siteContactApi (no ES modules in this
 * codebase yet — same loadOnce pattern).
 *
 * Each method returns a Promise resolving to the parsed `data` payload, or
 * { turboStream: true } when the server returned a Turbo Stream and Turbo has
 * rendered it. Errors throw with .message, .status, and .details set.
 */
loadOnce('site-contact-api', function () {
    var request = window.apiClient.request;

    function sitePath(siteId) {
        return '/site/' + encodeURIComponent(siteId) + '/site-contacts';
    }

    window.siteContactApi = {
        list: function (siteId) {
            return request('GET', sitePath(siteId), null, { acceptStream: false });
        },
        create: function (siteId, data, opts) {
            return request('POST', sitePath(siteId), data, opts);
        },
        update: function (contactId, data, opts) {
            return request('PUT', '/site-contacts/' + encodeURIComponent(contactId), data, opts);
        },
        remove: function (contactId, opts) {
            return request('DELETE', '/site-contacts/' + encodeURIComponent(contactId), null, opts);
        }
    };
});
